<app-online-store-form-wrapper
  data-testid="online-store-add-container"
  #formWrapper
  [config]="config"
  [editMode]="false"
  [viewMode]="false"
></app-online-store-form-wrapper>
